(function () {
  function initCarousel(section) {
    var track = section.querySelector('.na-track');
    var prev = section.querySelector('.na-arrow--prev');
    var next = section.querySelector('.na-arrow--next');
    if (!track) return;

    function updateArrows() {
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

      if (prev) {
        prev.style.opacity = atStart ? '0.3' : '1';
        prev.style.pointerEvents = atStart ? 'none' : 'auto';
      }
      if (next) {
        next.style.opacity = atEnd ? '0.3' : '1';
        next.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
    }

    function cardStep() {
      var card = track.querySelector('.na-card-wrapper');
      return card ? card.offsetWidth + 12 : 232;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    // Desktop click-and-drag scroll
    var isDown = false;
    var dragStartX = 0;
    var dragScrollLeft = 0;
    var didDrag = false;

    track.style.cursor = 'grab';

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      didDrag = false;
      dragStartX = e.pageX - track.offsetLeft;
      dragScrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollBehavior = 'auto';
      e.preventDefault();
    });

    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.style.cursor = 'grab';
      track.style.scrollBehavior = '';
    });

    track.addEventListener('mouseup', function () {
      isDown = false;
      track.style.cursor = 'grab';
      track.style.scrollBehavior = '';
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - track.offsetLeft;
      var walk = (x - dragStartX) * 1.5;
      if (Math.abs(walk) > 4) didDrag = true;
      track.scrollLeft = dragScrollLeft - walk;
    });

    // Suppress link clicks that fire after a drag
    track.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    // Quick-add — .gw-quick-add--soldout (the bell) is handled by the
    // notify-me wiring below instead, same split every other carousel
    // on the site uses (see e.g. main-collection-type-carousel.liquid).
    section.querySelectorAll('.na-card-wrapper .gw-quick-add').forEach(function (btn) {
      if (btn.classList.contains('gw-quick-add--soldout')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = parseInt(btn.dataset.variantId);
        if (!variantId) return;
        var collectionHandle = btn.dataset.collection;
        window.gwInterceptAddToCart(variantId, 1, collectionHandle);
      });
    });
  }

  // Notify me (back in stock) — reuses the site's existing Cartbite
  // widget, identically to every other product-card carousel (see
  // sections/main-collection-type-carousel.liquid's own copy of this
  // exact block). Cartbite only auto-builds its modal DOM on
  // /products/... URLs, so here (homepage) we fetch the product
  // ourselves and call window.initVar.renderStockWidget() first to
  // force it to build the modal on demand (idempotent) before opening
  // it via stockWidgetClicked. Guarded by the same page-wide flag
  // every other copy uses, so whichever one's script runs first wires
  // it — harmless/idempotent if more than one carousel type is on the
  // same page.
  if (!window.__gwNotifyWired) {
    window.__gwNotifyWired = true;
    var gwHandleNotifyTrigger = function (e) {
      var el = e.target.closest('.gw-quick-add--soldout');
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (!window.growConfig || typeof window.growConfig.stockWidgetClicked !== 'function') return;
      var handle = el.getAttribute('data-product-handle');
      var variantId = el.getAttribute('data-variant-id');
      if (!handle) return;
      fetch('/products/' + handle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          var variant = product.variants.filter(function (v) { return String(v.id) === String(variantId); })[0] || product.variants[0];
          var ensure = (window.initVar && typeof window.initVar.renderStockWidget === 'function')
            ? window.initVar.renderStockWidget(product, variant)
            : Promise.resolve();
          return Promise.resolve(ensure).then(function () {
            window.growConfig.stockWidgetClicked(e);
          });
        })
        .catch(function () {});
    };
    document.addEventListener('click', gwHandleNotifyTrigger);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') gwHandleNotifyTrigger(e);
    });
  }

  document.querySelectorAll('.na-section').forEach(initCarousel);
})();
